var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHouse3 = function SvgHouse3(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets / Icons / Bold / house-3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-174.000000, -809.000000)",
    fill: "#030F40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-fill-color",
    transform: "translate(174.000000, 809.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.707,11.293 L12.707,0.293 C12.3165001,-0.0973819383 11.6834999,-0.0973819383 11.293,0.293 L0.293,11.293 C0.00709208442,11.5789943 -0.078421906,12.0090366 0.0763220219,12.3826546 C0.23106595,12.7562725 0.595604102,12.9999137 1,13 L2.25,13 C2.38807119,13 2.5,13.1119288 2.5,13.25 L2.5,23 C2.5,23.5522847 2.94771525,24 3.5,24 L9.25,24 C9.38807119,24 9.5,23.8880712 9.5,23.75 L9.5,19 C9.5,17.6192881 10.6192881,16.5 12,16.5 C13.3807119,16.5 14.5,17.6192881 14.5,19 L14.5,23.75 C14.5,23.8880712 14.6119288,24 14.75,24 L20.5,24 C21.0522847,24 21.5,23.5522847 21.5,23 L21.5,13.25 C21.5,13.1119288 21.6119288,13 21.75,13 L23,13 C23.4043959,12.9999137 23.7689341,12.7562725 23.923678,12.3826546 C24.0784219,12.0090366 23.9929079,11.5789943 23.707,11.293 Z M12,12 C10.6192881,12 9.5,10.8807119 9.5,9.5 C9.5,8.11928813 10.6192881,7 12,7 C13.3807119,7 14.5,8.11928813 14.5,9.5 C14.5,10.1630412 14.2366079,10.798926 13.767767,11.267767 C13.298926,11.7366079 12.6630412,12 12,12 L12,12 Z"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHouse3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/house-3.e2b8fa19efd78615d2d669c18a399f1f.svg";